/**
 * Termos de Uso da Plataforma Fluxvet – versão para owner (contratante).
 * Exibido quando termOf === "owner" e currentFeatures.defaultApp === false (app Fluxvet).
 */
import { Box, Container, Typography } from "@mui/material";

export default function FluxvetOwnerTerms() {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h6" align="center" gutterBottom fontWeight={700}>
        TERMOS DE USO DA PLATAFORMA FLUXVET
      </Typography>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          1. CONSIDERAÇÕES INICIAIS
        </Typography>
        <Typography paragraph>
          1.1. O presente documento contém os termos e as condições de uso da
          &quot;Plataforma Fluxvet&quot; ou &quot;Fluxvet&quot;, desenvolvida pela FLUXMED –
          PLATAFORMA PARA SERVICOS DIGITAIS DE SAUDE LTDA, empresa de tecnologia
          com sede em Brasília-DF, inscrita no CNPJ nº 57.877.539/0001-40,
          situada no SIG QUADRA 1, 385, sala 313, Zona Industrial, CEP: 70.610-410,
          Brasília/DF, será referida como &quot;Fluxvet&quot;, &quot;Pataforma Fluxvet&quot; ou
          simplesmente &quot;Plataforma&quot;. Este documento é de adesão por parte do
          Contratante identificada por meio da Plataforma no momento de criação
          de seu cadastro de CNPJ ou CPF (Contratante).
        </Typography>
        <Typography paragraph>
          1.2. A Contratante e a Fluxvet, sempre que em conjunto referidas, para
          efeitos deste documento de adesão, serão designadas como
          &quot;Partes&quot; ou, individualmente, como &quot;Parte&quot;, e concordam, em
          boa-fé e com livre e espontânea vontade, o quanto segue.
        </Typography>
        <Typography paragraph>1.3. Preliminarmente, considerando que:</Typography>
        <Typography paragraph>
          1.3.1. A Contratante é uma organização de saúde que exerce atividades
          de atenção à saúde veterinaria, ou um médico veterinário devidamente
          cadastrado no Conselho de classe CFMV – Conselho Federal de Medicina
          Veterinária. O CPF, ou caso for o cadastro de um CNPJ, as informações
          providas, inclusive CNAE, da Contratante será verificado junto à
          Receita Federal no momento da realização do cadastro na Plataforma.
        </Typography>
        <Typography paragraph>
          1.3.2. A Fluxmed é uma empresa de tecnologia que exerce atividades
          de tecnologia da informação voltadas para o desenvolvimento de
          programas de computador sob encomenda. É a detentora da marca
          &quot;Fluxvet&quot;.
        </Typography>
        <Typography paragraph>
          1.3.3. A Fluxmed é a desenvolvedora e detentora de todos os direitos
          de propriedade material e imaterial relacionados ao software que
          compreende a Plataforma de Desenvolvimento de Serviços Digitais para a
          Saúde (&quot;Plataforma&quot;) denominada &quot;Plataforma Fluxmed&quot;, e outrora
          &quot;Plataforma Fluxvet&quot;.
        </Typography>
        <Typography paragraph>
          1.3.4. A Plataforma consiste em 03 (três) funcionalidades, desenvolvidas
          em conformidade com a Lei Geral de Proteção de Dados Pessoais (Lei n.
          13.709/2018 – &quot;LGPD&quot;):
        </Typography>
        <Typography paragraph>
          1.3.4.1. Fluxvet para clinicas veterinárias: ideal para, por exemplo,
          consultórios individuais, pequenas clínicas, credenciados ou não de
          planos de saúde. Permite o registro clínico, agendamento para
          pacientes e profissionais de saúde, teleatendimento, prescrições
          eletrônicas CFM/ICP Brasil. Consiste em um Registro Eletrônico de
          Saúde (SRES) do paciente, atendendo aos padrões de representação,
          terminologia e interoperabilidade de forma integrada em padrão HL7
          FHIR.
        </Typography>
        <Typography paragraph>
          1.3.4.2. Fluxvet API´s: plataforma de interoperabilidade HL7 FHIR cujo
          público-alvo são os interessados em utilizar os recursos da Plataforma
          em produtos ou sistemas de terceiros ou próprios, permitindo o acesso
          padronizado HL7 FHIR a uma moderna plataforma de desenvolvimento para
          serviços digitais de saúde, que entrega valor agregado, agendamentos,
          registros clínicos, MPI, gestão de terminologias e data lake de
          informações clínicas, e ainda, interoperabilidade escalável. Trata-se
          de serviço acessório que estará sujeito às condições de termo de uso
          específico com preço específico.
        </Typography>
        <Typography paragraph>
          1.3.4.3. Fluxvet Analítico: permite o tratamento de dados já ingeridos
          e processados na Plataforma e, consequentemente a gestão de saúde
          populacional, administrativas e do cuidado a partir do da base de
          dados com informações clínicas e administrativas normalizadas, é
          possível criar painéis analíticos anonimizados, alinhados às
          necessidades de gestão de saúde populacional e muito mais, com
          segurança e sigilo. Trata-se de serviço acessório que estará sujeito
          às condições de termo de uso específico com preço específico.
        </Typography>
        <Typography paragraph>
          1.3.5. Em resumo, a Plataforma consiste em um software que realiza
          funções de comunicação e arquivamento de dados de saúde veterinária
          (prontuário eletrônico, agendamento, transmissão de dados e
          comunicação). Assim sendo, a Plataforma não oferece funcionalidades
          relacionadas a prevenção, diagnóstico, tratamento, reabilitação ou
          anticoncepção e, desta forma, ela não se enquadra nas regras
          descritas na Resolução da Diretoria Colegiada (RDC) nº 185 de 22 de
          outubro de 2001 e na RDC nº 657/2022, ambas da Agência Nacional de
          Vigilância Sanitária (Anvisa). Portanto, a Plataforma não é
          considerada um software como dispositivo médico (Software as a
          Medical Device – SaMD) e não precisa ser regularizada junto a
          Gerência de Tecnologia em Equipamentos (GQUIP/GGTPS/ANVISA).
        </Typography>
        <Typography paragraph>
          1.3.6. A Contratante tem o interesse de contratar e usar a Plataforma
          Fluxvet, hospedado e acessível centralmente via internet/nuvem
          localizada no Brasil, na modalidade de Software como Serviço (Software
          as a Service – SaaS), acompanhada de serviços prestados pela Fluxvet.
          A Contratante será exclusivamente responsável pela gestão da
          informação clínica e todas as ações e atividades relacionadas à
          prestação de serviços de saúde e pela atuação de seus profissionais da
          saúde, que devem estar a ela vinculados.
        </Typography>
        <Typography paragraph>
          1.3.7. As Partes são titulares de informações comerciais e técnicas
          de caráter sigiloso, exclusivas, relacionadas com o seu ramo de
          atuação, sendo o caráter confidencial dessas informações e
          documentação de valor substancial e inestimável para elas. As Partes
          declaram e garantem que todos os direitos, materiais e imateriais,
          relacionados à Plataforma e aos serviços a ela relacionados são de
          propriedade exclusiva da Fluxvet.
        </Typography>
        <Typography paragraph>
          1.3.8. Todas as informações e/ou materiais que digam respeito, direta
          ou indiretamente, ao objeto deste documento, em razão de sua natureza
          estratégica, deverão ser tratados com o mais absoluto sigilo e a mais
          rigorosa confidencialidade, de modo a evitar, por qualquer meio ou
          forma, o seu conhecimento e/ou utilização por parte de terceiros, seja
          durante a sua vigência ou mesmo após ela, sob pena de a Parte
          infratora arcar com as perdas e danos resultantes do descumprimento
          desta obrigação, sem prejuízo das medidas judiciais e administrativas
          cabíveis;
        </Typography>
        <Typography paragraph>
          1.3.9. O dever de privacidade e sigilo de dados pessoais sensíveis
          referentes à saúde encontra abrigo constitucional, eis que o artigo 5º,
          X, da Constituição Federal qualifica como direito fundamental a
          inviolabilidade da intimidade, a vida privada, a honra e a imagem das
          pessoas, assegurado o direito a indenização pelo dano material ou
          moral decorrente de sua violação. Infra constitucionalmente, o
          artigo 21 do Código Civil estabelece que &quot;a vida privada da pessoa
          natural é inviolável, e o juiz, a requerimento do interessado,
          adotará as providências necessárias para impedir ou fazer cessar ato
          contrário a esta norma&quot;.
        </Typography>
        <Typography paragraph>
          1.3.10. As Partes protegem a confidencialidade de dados pessoais e
          dados sensíveis que lhe são confiados pelos titulares desses dados.
          Para isso, vêm implementando medidas de segurança, técnicas e
          administrativas, aptas a proteger dados pessoais e dados sensíveis
          contra acessos não autorizados e de situações acidentais, ou qualquer
          forma de tratamento inadequado, necessárias ao cumprimento da Lei
          Geral de Proteção de Dados (Lei nº 13.709/2018). Regras de boas
          práticas e de governança garantem que o tratamento de dados pessoais
          e sensíveis seja lícito, leal, transparente e limitado às finalidades
          autorizadas a que se destina. A coleta de dados pessoais e dados
          sensíveis para tratamento é realizada pelas Partes com base em
          medidas necessárias para assegurar a exatidão, integridade,
          confidencialidade, e anonimização, bem como garantir o respeito à
          liberdade, privacidade, inviolabilidade da intimidade, imagem, enfim,
          todos os direitos dos titulares, inclusive o exercício do direito de
          solicitar acesso, correção e eliminação de dados pessoais e sensíveis
          armazenados em banco de dados e sistemas digitais.
        </Typography>
        <Typography paragraph>
          1.3.11. Cada Parte observará e compromete-se a respeitar todos os
          direitos de propriedade intelectual, industrial e know how da outra
          Parte, sendo que nenhum Parte poderá utilizar de nenhum modo a
          marca, logotipo, nome comercial, domínio de internet, nem qualquer
          outro sinal distintivo pertencente à outra Parte sem sua prévia e
          expressa autorização por escrito e assinada por seus devidos
          representantes legais.
        </Typography>
        <Typography paragraph>
          1.3.12. As Partes observam a legislação brasileira que versa sobre
          privacidade e proteção de dados pessoais, inclusive a Constituição
          Federal, o Código de Defesa do Consumidor, o Código Civil, a Lei Geral
          de Proteção de Dados &quot;LGPD&quot; (Lei Federal nº 13.709/2018), o Marco
          Civil da Internet (Lei Federal nº 12.965/2014), seu decreto
          regulamentador (Decreto nº 8.771/2016) e, relativamente à Contratante, a
          Lei n. 12.842/2013 (Lei do Ato Médico), a Lei n. 8.078/90 (Código de
          Defesa do Consumidor) e, nas hipóteses cabíveis, aos ditames da Lei nº
          13.787/18 (Lei do Prontuário Eletrônico), , as demais normas
          setoriais ou gerais sobre proteção dos dados pessoais previstos em
          Resoluções do Conselho Federal de Medicina, como o Código de Ética
          Médica, e outros conselhos de classe da área da saúde.
        </Typography>
        <Typography paragraph>
          1.3.13. A Contratante reconhece e concorda que a Plataforma não
          realiza a gravação de teleconsulta.
        </Typography>
        <Typography paragraph>
          1.3.14. Para os efeitos deste Documento, a Contratante atua como
          &quot;controlador de dados&quot;, a quem compete as decisões referentes ao
          tratamento de dados pessoais de seu paciente, recaindo sobre a
          Contratante as obrigações atribuídas pela LGPD. É perante o
          controlador de dados que o paciente titular de dados exerce os seus
          direitos dispostos no art. 18 da LGPD. Deve, ainda, comprovar que o
          consentimento para compartilhar dados de saúde com a Fluxvet foi
          obtido do paciente titular de dados. Recai sobre a Contratante a
          obrigação de comunicar tempestivamente à Autoridade Nacional de
          Proteção de Dados (&quot;ANPD&quot;) e ao paciente-titular a ocorrência de
          incidente de segurança que possa acarretar risco ou dano relevante ao
          paciente -titular.
        </Typography>
        <Typography paragraph>
          1.3.15. A Fluxvet atua como &quot;operador de dados&quot; perante a Contratante e
          deve realizar o tratamento de dados pessoais compartilhados pela
          Contratante em nome da Contratante e relacionadas às finalidades da
          Plataforma Fluxvet contratadas pela Contratante. A Fluxvet só poderá
          tratar os dados para a finalidade previamente estabelecida pela
          Contratante, que é o controlador.
        </Typography>
        <Typography paragraph>
          1.3.16. O tratamento de dados pessoais e dados pessoais sensíveis do
          paciente da Contratante fica sujeito à coleta, por parte da
          Contratante, do consentimento livre, informado e inequívoco do
          titular-paciente pelo qual ele concorda com o tratamento de seus dados
          pessoais e dados pessoais sensíveis (art. 11, I da LGPD) pela
          Contratante, para finalidades determinadas relacionadas à assistência e
          gestão de sua saúde. A própria Plataforma Fluxvet oferece mecanismos
          para a observância do consentimento, conforme &quot;Termos e Condições de
          Uso&quot; e Política de Privacidade, ambos dispostos no ambiente logado e
          não logado do Aplicativo/web, que pode ser revogado a qualquer
          momento pelo paciente.
        </Typography>
        <Typography paragraph>
          1.3.17. As Partes declaram que reconhecem que dados pessoais sensíveis
          como os de saúde pertencem a uma categoria especial, sendo as
          hipóteses para o tratamento mais rigorosas. As Partes declaram e
          garantem que a LGPD veda o tratamento de dados pessoais que possa
          resultar em discriminações ilícitas ou abusivas como, por exemplo, a
          prática de seleção de riscos.
        </Typography>
        <Typography paragraph>
          1.3.18. Considera-se &quot;paciente-titular de dados (ou
          &quot;paciente-titular&quot;)&quot; a pessoa natural assistida pela Contratante no
          âmbito da prestação de serviços de saúde ofertados pela Contratante. O
          paciente é a pessoa natural a quem se referem os dados pessoais que
          são objeto de tratamento no contexto do objeto deste Documento.
        </Typography>
        <Typography paragraph>
          1.3.19. Considera-se &quot;usuário autorizado&quot; o profissional de saúde
          vinculado à Contratante que receberá o login de acesso à Plataforma
          Fluxvet. Recai sobre a Contratante a responsabilidade integral sobre
          os atos do usuário-autorizado que impliquem em tratamento irregular e
          inseguro de dados de saúde e em incidentes de segurança sobre dados
          pessoais do paciente-titular.
        </Typography>
        <Typography paragraph>
          1.4. As Partes declaram que concordam e aceitam, em boa-fé e livre
          vontade, os Termos e Condições de Uso da Plataforma Fluxvet, conforme
          o presente documento, que mutuamente outorgam e aceitam.
        </Typography>
      </Box>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          2. OBJETO
        </Typography>
        <Typography paragraph>
          2.1. Este documento tem a finalidade de determinar as condições e os
          termos de uso da Plataforma Fluxvet e as obrigações das Partes cujo
          objeto compreende:
        </Typography>
        <Typography paragraph>
          2.1.1. A adesão, por parte da Contratante, de uso do software
          denominado Fluxvet.
        </Typography>
        <Typography paragraph>
          2.2. Incluídos no preço de subscrição, os serviços atrelados ao objeto
          do Documento e prestados pela Fluxvet serão os seguintes:
        </Typography>
        <Typography paragraph>
          2.2.1. Suporte Técnico e Manutenção: Assistência para resolver questões
          técnicas para que o software funcione de maneira otimizada. Isso inclui
          atualizações regulares para corrigir bugs e melhorar a segurança e a
          disponibilidade. Por padrão as atualizações de software referente a
          correção de bugs, melhoria de segurança e disponibilidade serão
          realizados pela monitoração ativa da plataforma. Será disponibilizado
          um canal digital para abertura de chamados de suporte técnico. Será
          realizada triagem de criticidade do chamado com resposta ao cliente em
          até 24 horas. De acordo com a criticidade, alta, média ou baixa, será
          informado o prazo de ajuste, que pode ser de até 5 dias úteis.
        </Typography>
        <Typography paragraph>
          2.2.2. Instalação e Configuração: Ajuda na instalação do software e na
          configuração inicial para assegurar que o software esteja pronto para
          uso conforme as necessidades específicas do usuário da Contratante. Os
          manuais do usuário serão disponibilizados na própria Plataforma e
          integrarão o presente documento.
        </Typography>
        <Typography paragraph>
          2.2.3. Customização: se desejado pela Contratante, serviços que adaptam
          o software às necessidades específicas da Contratante, incluindo o
          desenvolvimento de funcionalidades personalizadas ou integrações com
          outros sistemas, não estão inclusos no preço desta subscrição. Para
          customizações, entre em contato com a Fluxvet através do site.
          https://fluxvet.com.br
        </Typography>
        <Typography paragraph>
          2.2.4. Backup e Recuperação de Dados: a Plataforma é hospedada
          centralmente via internet/nuvem. O backup da Plataforma será
          automatizado com recursos da nuvem. A Plataforma oferece mecanismos
          para que a Contratante realize backups de seus registros e é a
          responsável por isso.
        </Typography>
        <Typography paragraph>
          2.2.5. Atualizações e Upgrades: Fornecimento de novas versões do
          software para garantir acesso contínuo às últimas funcionalidades,
          melhorias de desempenho e correções de segurança. É possível que novas
          funcionalidades resultem em ajuste no preço.
        </Typography>
        <Typography paragraph>
          2.3. As Partes declaram e reconhecem que o paciente é o protagonista
          de sua própria saúde e o titular de seus dados pessoais e dados
          pessoais sensíveis, podendo revogar, ou não, o consentimento de acesso
          às suas informações.
        </Typography>
      </Box>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          3. RESPONSABILIDADES
        </Typography>
        <Typography paragraph>3.1. A Fluxvet é responsável por:</Typography>
        <Typography paragraph>
          3.1.1. Observar com os termos e usos deste documento, manter a
          disponibilidade e qualidade da Plataforma.
        </Typography>
        <Typography paragraph>
          3.1.2. Manter atualizados os Manuais de usuário.
        </Typography>
        <Typography paragraph>
          3.1.3. Investir em constantes evoluções tecnológicas em prol da saúde
          digital.
        </Typography>
        <Typography paragraph>
          3.1.4. No caso de cancelamento ou extinção do Documento, por qualquer
          motivo, a Fluxvet obriga-se a manter a Plataforma disponível à
          Contratante, com acesso apenas de leitura de dados, pelo período de
          30 (trinta) dias para que a Contratante possa proceder com a
          observância da Lei n. 13.787/2018 que versa sobre a digitalização e a
          utilização de sistemas informatizados para a guarda, o armazenamento e
          o manuseio de prontuário de paciente.
        </Typography>
        <Typography paragraph>
          3.1.5. Notificar a Contratante no caso de incidente de segurança em até
          48 (quarenta e oito) horas do conhecimento do incidente e prestar os
          esclarecimentos necessários e relacionados ao incidente à Contratante.
        </Typography>
        <Typography paragraph>
          3.1.6. Manter a emissão tempestiva de Notas Fiscais eletrônicas,
          referentes à subscrição de uso da Contratante.
        </Typography>
        <Typography paragraph>
          3.1.7. Informar por e-mail a Contratante sobre problemas de pagamento
          mantendo o uso da Plataforma Fluxvet por 10 dias após a informação do
          problema do pagamento.
        </Typography>
        <Typography paragraph>
          3.2. Além das obrigações previstas neste instrumento, e na legislação
          aplicável, a Contratante se compromete, ainda, a:
        </Typography>
        <Typography paragraph>
          3.2.1. Efetuar todos os pagamentos da subscrição tempestivamente.
        </Typography>
        <Typography paragraph>
          3.2.2. Garantir e manter uma conexão de internet com velocidade e
          estabilidade suficientes para suportar o desempenho eficaz da
          Plataforma.
        </Typography>
        <Typography paragraph>
          3.2.3. Observar as instruções para a utilização da Plataforma e Manuais
          de usuário
        </Typography>
        <Typography paragraph>
          3.2.4. Não realizar modificações, atualizações ou alterações no
          software (Plataforma) sem a prévia aprovação por escrito da Fluxvet.
          Qualquer modificação desautorizada pode levar a problemas de
          compatibilidade ou funcionamento e resultar em violação das condições
          de uso do software, isentando a Fluxvet de qualquer responsabilidade.
        </Typography>
        <Typography paragraph>
          3.2.5. A Contratante está proibida de sublicenciar, alugar ou emprestar
          o uso software (Plataforma) a terceiros.
        </Typography>
        <Typography paragraph>
          3.2.6. Em caso de instabilidades, falhas ou qualquer outro problema
          técnico com o software (Plataforma), a Contratante se obriga a abrir
          chamados de suporte técnico imediatamente ao conhecimento do
          problema.
        </Typography>
      </Box>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          4. LIMITAÇÃO DE RESPONSABILIDADE E FORÇA MAIOR
        </Typography>
        <Typography paragraph>
          4.1. Limitação de Responsabilidade e Força Maior. As Partes declaram e
          concordam que a responsabilidade total da Fluxvet, sob qualquer
          circunstância decorrente ou relacionada ao objeto deste documento, se
          comprovada será limitada à natureza da atuação econômica da Fluxvet e
          suas responsabilidades. Para não haver dúvidas, em nenhuma hipótese a
          Fluxvet será responsabilizada por danos sofridos pelo paciente da
          Contratante relacionados à prestação de serviço de saúde pela
          Contratante.
        </Typography>
        <Typography paragraph>
          4.1.1. Força Maior: Nenhuma das partes será responsável por falhas ou
          atrasos no desempenho de suas obrigações sob este documento devido a
          eventos de força maior, que incluem, mas não se limitam a desastres
          naturais, guerras, atos de terrorismo, greves, falhas ou atrasos de
          Internet, falhas de energia, e intervenções governamentais. Em tais
          circunstâncias, os prazos para o desempenho serão prorrogados por um
          período de tempo razoável, considerando a duração do evento de força
          maior. A seguir encontram-se exemplos que isentam a Fluxvet de
          qualquer responsabilidade perante a Contratante:
        </Typography>
        <Typography paragraph>
          4.1.1.1. Falhas na internet contratada pela contratante: a empresa de
          tecnologia não pode ser responsabilizada por problemas de
          conectividade que ocorram devido a falhas na internet contratada pela
          Contratante;
        </Typography>
        <Typography paragraph>
          4.1.1.2. Manutenção programada: interrupções agendadas para manutenção
          ou atualizações do sistema, sobre as quais a Contratante foi
          previamente notificada;
        </Typography>
        <Typography paragraph>
          4.1.1.3. Desastres naturais: eventos fora do controle da empresa, como
          terremotos, furacões, enchentes ou outros desastres naturais que afetem
          a infraestrutura necessária para o serviço;
        </Typography>
        <Typography paragraph>
          4.1.1.4. Ataques cibernéticos de terceiros: ataques por hackers ou
          outras entidades maliciosas que não sejam resultado de negligência
          por parte da Fluxvet;
        </Typography>
        <Typography paragraph>
          4.1.1.5. Falhas de equipamentos da Contratante: problemas causados por
          hardware obsoleto ou mal mantido pela Contratante, que afetem a
          operação do SaaS;
        </Typography>
        <Typography paragraph>
          4.1.1.6. Alterações não autorizadas pela Fluxvet: modificações feitas
          pela Contratante na configuração ou no uso da plataforma sem
          consentimento ou aprovação da Fluxvet;
        </Typography>
        <Typography paragraph>
          4.1.1.7. Conflitos de software causados por terceiros: interferências
          ou incompatibilidades causadas por software ou hardware de terceiros
          não fornecidos pela Fluxvet;
        </Typography>
        <Typography paragraph>
          4.1.1.8. Limitações tecnológicas conhecidas: restrições ou limitações
          tecnológicas da plataforma que são conhecidas e documentadas e sobre as
          quais a Contratante foi informada;
        </Typography>
        <Typography paragraph>
          4.1.1.9. Uso inadequado da plataforma: uso do software de maneira
          contrária às instruções fornecidas ou às práticas recomendadas
          estabelecidas pela Fluxvet;
        </Typography>
        <Typography paragraph>
          4.1.1.10. Força maior: qualquer outro evento fora do controle
          razoável da Fluxvet, como greves, tumultos, guerra, pandemias, ou
          intervenções governamentais que impeçam a continuidade dos serviços;
        </Typography>
        <Typography paragraph>
          4.2. Quando comprovado que o problema técnico reside na nuvem, a Fluxvet
          não será responsável por eventos como instabilidade ou até mesmo
          indisponibilidade da Plataforma.
        </Typography>
      </Box>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          5. VIGÊNCIA E PREÇO DOS SERVIÇOS
        </Typography>
        <Typography paragraph>
          5.1. A vigência da subscrição de uso e o preço serão disponibilizados
          online pelos recursos da Plataforma Fluxvet e poderão ser ajustados ao
          longo da evolução tecnológica das funcionalidades. Os pagamentos
          serão antecipados. No caso de extinção antecipada da subscrição,
          prevalecerá o preço contratado e nenhum estorno será efetuado por
          parte da Fluxvet.
        </Typography>
      </Box>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          6. RESCISÃO
        </Typography>
        <Typography paragraph>
          6.1. A subscrição poderá ser cancelada pela Contratante a qualquer
          momento pelos mecanismos oferecidos pela Plataforma Fluxvet.
        </Typography>
        <Typography paragraph>
          6.2. A Fluxvet poderá cancelar a subscrição por justo motivo, devendo
          notificar a Contratante com 10 (dez) dias de antecedência. Caso for
          detectado o uso indevido da Plataforma Fluxvet, por parte da
          Contratante, a Fluvet notificará a Contratante e suspenderá
          imediatamente a subscrição até que seja corrigido.
        </Typography>
      </Box>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          7. CONFIDENCIALIDADE
        </Typography>
        <Typography paragraph>
          7.1. As Partes se comprometem a guardar o mais absoluto sigilo das
          informações fornecidas pela outra parte para a consecução do objeto
          deste Documento, consideradas de valor inestimável para ambas,
          comprometendo-se a as usarem-nas apenas para os fins específicos a que
          se refere a presente contratação. A parte que não cumprir esta
          obrigação será responsável por eventuais danos causados que venham a
          ser apurados, oportunamente.
        </Typography>
        <Typography paragraph>
          7.2. As Partes, neste ato, obrigam-se, por si, seus representantes,
          prepostos, empregados e/ou subcontratados a tratar com absoluto sigilo
          e confidencialidade toda e qualquer informação, dados econômicos ou
          técnicos, desenhos, projetos, procedimentos, manuais, disponibilizados
          por ambas durante a vigência do presente documento, não podendo, em
          nenhuma hipótese, revelá-los a terceiros e/ou divulgá-los sob qualquer
          forma e pretexto, ou utilizá-los em proveito próprio ou de terceiros
          para fins estranhos ao do presente documento, salvo mediante expressa
          autorização por escrito dos demais interessados.
        </Typography>
        <Typography paragraph>
          7.3. As partes adotarão rigorosas medidas de proteção das informações
          confidenciais da outra Parte para evitar que elas sejam de qualquer
          modo divulgadas, reveladas, publicadas, vendidas, cedidas ou de
          qualquer outra forma transferidas pela Parte Receptora, seus
          representantes, prepostos, empregados e/ou subcontratados.
        </Typography>
        <Typography paragraph>
          7.4. A Contratante é a única responsável pela origem das informações
          por ela prestadas para a Fluxvet para a consecução dos Serviços ora
          contratados e neste ato expressamente declara que o conteúdo da base
          de vidas e das informações nela contidas e que serão fornecidas à
          Fluxvet não viola qualquer lei ou qualquer direito de terceiros,
          incluindo, sem limitação, direitos de propriedade intelectual e
          direitos autorais, isentando e indenizando a Fluxvet, a qualquer
          tempo, mesmo após a expiração ou término deste documento por qualquer
          motivo, de qualquer responsabilidade que decorra da informação
          equivocada ou falsa dos dados fornecidos à Fluxvet.
        </Typography>
        <Typography paragraph>
          7.4.1. A Fluxvet está isenta de responsabilidade pelo conteúdo de
          toda e qualquer informação, dados pessoais, econômicos ou técnicos
          relacionados ao beneficiário, disponibilizados pela Contratante, a
          qual é responsável pela origem e exatidão das informações que
          disponibilizará à Fluxvet para a realização dos serviços objeto do
          presente instrumento.
        </Typography>
        <Typography paragraph>
          7.5. A Fluxvet expressamente compromete-se a adotar as medidas
          técnicas e organizacionais necessárias para garantir a segurança dos
          dados pessoais dos aderentes da Contratante e evitar a sua alteração,
          perda e acesso não autorizados, dada a natureza pessoal dos dados
          armazenados e os riscos a que estão expostos, quer da ação humana ou o
          ambiente físico ou eletrônico em que estejam armazenados.
        </Typography>
        <Typography paragraph>
          7.6. A Contratante está ciente, ainda, de que o prontuário, guias,
          informativos enviados pela Fluxvet aos beneficiários são documentos
          não compartilháveis, cuja propriedade pertence exclusivamente ao
          beneficiário, sendo que Fluxvet reserva o direito de não fornecer
          cópia à Contratante, em hipótese alguma, sob pena de violação do sigilo
          e privacidade do beneficiário, exceto mediante o consentimento
          inequívoco, nos termos da Lei.
        </Typography>
        <Typography paragraph>
          7.7. As obrigações relativas à confidencialidade das informações
          técnicas e de negócio, trocadas entre as Partes para a execução deste
          Documento, perdurarão pelo prazo de 02 (dois) anos após a extinção
          deste Documento, exceto no que se tratar de segredo comercial e
          industrial, e direitos personalíssimos de indivíduos, como dados
          pessoais sensíveis.
        </Typography>
      </Box>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          8. PRIVACIDADE E PROTEÇÃO DE DADOS PESSOAIS
        </Typography>
        <Typography paragraph>
          8.1. Relativamente à Lei Geral de Proteção de Dados Pessoais (Lei
          13.709/2018 – LGPD), sem prejuízo das demais disposições dispostas
          neste instrumento, as Partes declaram o seguinte:
        </Typography>
        <Typography paragraph>
          8.1.1. As Partes protegem a confidencialidade de dados pessoais e
          dados sensíveis que lhe são confiados pelos titulares desses dados em
          razão deste documento. Declaram, inclusive em nome de seus
          empregados, cooperados, prepostos e subcontratados que cumprem a
          legislação brasileira sobre privacidade, disposta na Constituição
          Federal, o Código de Defesa do Consumidor, o Código Civil, a Lei
          Geral de Proteção de Dados &quot;LGPD&quot; (Lei Federal nº 13.709/2018), o
          Marco Civil da Internet (Lei Federal nº 12.965/2014), seu decreto
          regulamentador (Decreto nº 8.771/2016) e demais normas setoriais ou
          gerais sobre proteção de dados pessoais. Para isso, vêm implementando
          medidas de segurança, técnicas e administrativas, aptas a proteger
          dados pessoais e dados sensíveis contra acessos não autorizados e de
          situações acidentais, ou qualquer forma de tratamento inadequado,
          necessárias ao cumprimento da Lei Geral de Proteção de Dados (Lei nº
          13.709/2018).
        </Typography>
        <Typography paragraph>
          8.1.2. Regras de boas práticas e de governança garantem que o
          tratamento de dados pessoais e sensíveis seja lícito, leal, limitado
          às finalidades autorizadas a que se destina e respeitando-se os
          princípios da transparência, necessidade, proporcionalidade e
          não-discriminação. A coleta de dados pessoais e dados sensíveis para
          tratamento é realizada pelas Partes com base em medidas necessárias
          para assegurar a exatidão, integridade, confidencialidade, e
          anonimização, bem como garantir o respeito à liberdade, privacidade,
          inviolabilidade da intimidade, imagem, enfim, todos os direitos e
          liberdades dos titulares, inclusive o exercício do direito de
          solicitar acesso, correção e eliminação de dados pessoais e sensíveis
          armazenados em banco de dados e sistemas digitais, exceto quando a
          conservação permitida por lei ou obrigação regulatória (art. 16. I da
          LGPD)
        </Typography>
        <Typography paragraph>
          8.1.3. As Partes deverão possuir política de privacidade, diretrizes de
          segurança da informação e mecanismos de mitigação de riscos, com vistas
          a garantir a segurança do tratamento de dados pessoais e dados
          pessoais sensíveis, por exemplo, relatório de impacto à proteção de
          dados pessoais (art. 5º, XVII da LGPD), a fim de evitar incidentes de
          segurança como vazamento de informações, inclusive causados
          internamente, com evidências acessíveis de que tal conteúdo é
          comunicado e disseminado para todos seus aderentes .
        </Typography>
        <Typography paragraph>
          8.1.4. Para fins deste Documento a Fluxvet atua como &quot;Operador de
          dados&quot;, nos termos da LGPD e a Contratante atua como &quot;Controlador
          de dados&quot;, nos termos da LGPD.
        </Typography>
        <Typography paragraph>
          8.1.4.1. A Fluxvet responderá solidariamente com a Contratante pelos
          danos causados pelo tratamento quando ficar comprovado que ela
          descumpriu as obrigações da legislação de proteção de dados ou quando
          não tiver seguido as instruções lícitas da Contratante, salvo nos
          casos de exclusão previstos no art. 43 da LGPD.
        </Typography>
        <Typography paragraph>
          8.1.4.2. A Contratante responderá solidariamente com a Fluxvet pelos
          danos causados ao titular pelo tratamento que estiverem diretamente
          envolvidos, salvo nos casos de exclusão previstos no art. 43 da LGPD.
        </Typography>
      </Box>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          9. DISPOSIÇÕES GERAIS E FINAIS
        </Typography>
        <Typography paragraph>
          9.1. O presente documento é firmado por pessoas inteiramente distintas,
          não podendo vir a ser caracterizado como qualquer forma de sociedade ou
          associação, sendo certo que as Partes não terão qualquer outro tipo de
          relação, a não ser o decorrente da relação regida por este Documento.
        </Typography>
        <Typography paragraph>
          9.2. Cada Parte será totalmente responsável por suas obrigações
          trabalhistas, fiscais ou civis, contraídas, inexistindo qualquer forma
          de vínculo trabalhista entre as Partes, e outras pessoas jurídicas de
          qualquer forma relacionadas com este Documento;
        </Typography>
        <Typography paragraph>9.3. As Partes comprometem-se a:</Typography>
        <Typography paragraph>
          9.3.1. Agir dentro das leis e regulamentos aplicáveis e obedecer aos
          mais estritos e rigorosos conceitos e princípios da ética, moralidade
          e boa-fé na condução dos negócios conjuntos, incluindo, mas não se
          limitando, a evitar relações, contatos e/ou parcerias comerciais com
          quaisquer agentes que por qualquer meio sabidamente participem ou
          tenham participado em atividades ilícitas, de qualquer espécie;
        </Typography>
        <Typography paragraph>
          9.3.2. Possuir todas as autorizações e licenças para operar seu negócio
          da forma como atualmente é operado e manter, durante o período de
          vigência deste Documento, todas as aprovações, permissões, registros e
          autorizações governamentais ou não governamentais TERMOS DE USO DA
          FLUXVET.
        </Typography>
      </Box>
    </Container>
  );
}
